<app-modal [Modal]="{
    title: 'Ingresa el código de verificación',
    closeTitle: true
}">
    <ng-container body>
        <article>
            <ng-container *ngIf="isQR; else otherContent">
                <p>Descarga la aplicacion Google Authenticator en <br>tu teléfono, luego escanea el código QR e introduce <br>el número generado para <br>activar este método</p>
                <picture>
                  <img [src]="data.qr" loading="lazy" alt="QR Google Authenticator">
                </picture>
              </ng-container>
              
              <ng-template #otherContent>
                <ng-container *ngIf="isEmail; else smsContent">
                  <p>Por favor ingresa el código que recibiste <br> en tu correo electrónico para <br> activar este método</p>
                </ng-container>
                
                <ng-template #smsContent>
                  <p>Por favor ingresa el código que recibiste <br> en tu teléfono celular vía SMS para <br> activar este método</p>
                </ng-template>
              </ng-template>
              

            <div class="container__otp" (keyup.enter)="VerifyCode()">
                <arc-otp-input 
                  [formControl]="codigoCtrl"
                  [allowNumbersOnly]="false"
                  [length]="largoCodigo"
                  [isPasswordInput]="false"
                  [disableAutoFocus]="false"
                  placeholder=""
                  [inputStyles]="{
                      width: '50px',
                      height: '50px',
                  }"          
              >
              </arc-otp-input>
            </div>
        </article>
    </ng-container>
    <ng-container footer>
        <button class="df-primario df-btn-xl" [disabled]="this.validationOTPCode()" (click)="VerifyCode()">
        Continuar
    </button>
    </ng-container>
</app-modal>